/* tslint:disable */
/* eslint-disable */
/**
 * My Title
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { UndercarriageAllInspectionsComponentResponse } from './UndercarriageAllInspectionsComponentResponse';
import {
    UndercarriageAllInspectionsComponentResponseFromJSON,
    UndercarriageAllInspectionsComponentResponseFromJSONTyped,
    UndercarriageAllInspectionsComponentResponseToJSON,
    UndercarriageAllInspectionsComponentResponseToJSONTyped,
} from './UndercarriageAllInspectionsComponentResponse';

/**
 * 
 * @export
 * @interface UndercarriageAllInspectionsResponse
 */
export interface UndercarriageAllInspectionsResponse {
    /**
     * 
     * @type {number}
     * @memberof UndercarriageAllInspectionsResponse
     */
    inspectionId?: number;
    /**
     * 
     * @type {Date}
     * @memberof UndercarriageAllInspectionsResponse
     */
    inspectionDate?: Date;
    /**
     * 
     * @type {string}
     * @memberof UndercarriageAllInspectionsResponse
     */
    siteName?: string;
    /**
     * 
     * @type {string}
     * @memberof UndercarriageAllInspectionsResponse
     */
    region?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UndercarriageAllInspectionsResponse
     */
    commodity?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UndercarriageAllInspectionsResponse
     */
    customerName?: string;
    /**
     * 
     * @type {string}
     * @memberof UndercarriageAllInspectionsResponse
     */
    assetNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof UndercarriageAllInspectionsResponse
     */
    assetModel?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UndercarriageAllInspectionsResponse
     */
    assetManufacturer?: string | null;
    /**
     * 
     * @type {number}
     * @memberof UndercarriageAllInspectionsResponse
     */
    totalMachineHours?: number | null;
    /**
     * 
     * @type {Date}
     * @memberof UndercarriageAllInspectionsResponse
     */
    undercarriageInstallDateLeft?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof UndercarriageAllInspectionsResponse
     */
    undercarriageInstallDateRight?: Date | null;
    /**
     * 
     * @type {number}
     * @memberof UndercarriageAllInspectionsResponse
     */
    undercarriageInstallHoursLeft?: number | null;
    /**
     * 
     * @type {number}
     * @memberof UndercarriageAllInspectionsResponse
     */
    undercarriageInstallHoursRight?: number | null;
    /**
     * 
     * @type {number}
     * @memberof UndercarriageAllInspectionsResponse
     */
    undercarriageHoursLeft?: number | null;
    /**
     * 
     * @type {number}
     * @memberof UndercarriageAllInspectionsResponse
     */
    undercarriageHoursRight?: number | null;
    /**
     * 
     * @type {number}
     * @memberof UndercarriageAllInspectionsResponse
     */
    totalPropelHours?: number | null;
    /**
     * 
     * @type {number}
     * @memberof UndercarriageAllInspectionsResponse
     */
    propelHoursLeft?: number | null;
    /**
     * 
     * @type {number}
     * @memberof UndercarriageAllInspectionsResponse
     */
    propelHoursRight?: number | null;
    /**
     * 
     * @type {Array<UndercarriageAllInspectionsComponentResponse>}
     * @memberof UndercarriageAllInspectionsResponse
     */
    components?: Array<UndercarriageAllInspectionsComponentResponse>;
}

/**
 * Check if a given object implements the UndercarriageAllInspectionsResponse interface.
 */
export function instanceOfUndercarriageAllInspectionsResponse(value: object): value is UndercarriageAllInspectionsResponse {
    return true;
}

export function UndercarriageAllInspectionsResponseFromJSON(json: any): UndercarriageAllInspectionsResponse {
    return UndercarriageAllInspectionsResponseFromJSONTyped(json, false);
}

export function UndercarriageAllInspectionsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): UndercarriageAllInspectionsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'inspectionId': json['inspectionId'] == null ? undefined : json['inspectionId'],
        'inspectionDate': json['inspectionDate'] == null ? undefined : (new Date(json['inspectionDate'])),
        'siteName': json['siteName'] == null ? undefined : json['siteName'],
        'region': json['region'] == null ? undefined : json['region'],
        'commodity': json['commodity'] == null ? undefined : json['commodity'],
        'customerName': json['customerName'] == null ? undefined : json['customerName'],
        'assetNumber': json['assetNumber'] == null ? undefined : json['assetNumber'],
        'assetModel': json['assetModel'] == null ? undefined : json['assetModel'],
        'assetManufacturer': json['assetManufacturer'] == null ? undefined : json['assetManufacturer'],
        'totalMachineHours': json['totalMachineHours'] == null ? undefined : json['totalMachineHours'],
        'undercarriageInstallDateLeft': json['undercarriageInstallDateLeft'] == null ? undefined : (new Date(json['undercarriageInstallDateLeft'])),
        'undercarriageInstallDateRight': json['undercarriageInstallDateRight'] == null ? undefined : (new Date(json['undercarriageInstallDateRight'])),
        'undercarriageInstallHoursLeft': json['undercarriageInstallHoursLeft'] == null ? undefined : json['undercarriageInstallHoursLeft'],
        'undercarriageInstallHoursRight': json['undercarriageInstallHoursRight'] == null ? undefined : json['undercarriageInstallHoursRight'],
        'undercarriageHoursLeft': json['undercarriageHoursLeft'] == null ? undefined : json['undercarriageHoursLeft'],
        'undercarriageHoursRight': json['undercarriageHoursRight'] == null ? undefined : json['undercarriageHoursRight'],
        'totalPropelHours': json['totalPropelHours'] == null ? undefined : json['totalPropelHours'],
        'propelHoursLeft': json['propelHoursLeft'] == null ? undefined : json['propelHoursLeft'],
        'propelHoursRight': json['propelHoursRight'] == null ? undefined : json['propelHoursRight'],
        'components': json['components'] == null ? undefined : ((json['components'] as Array<any>).map(UndercarriageAllInspectionsComponentResponseFromJSON)),
    };
}

export function UndercarriageAllInspectionsResponseToJSON(json: any): UndercarriageAllInspectionsResponse {
    return UndercarriageAllInspectionsResponseToJSONTyped(json, false);
}

export function UndercarriageAllInspectionsResponseToJSONTyped(value?: UndercarriageAllInspectionsResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'inspectionId': value['inspectionId'],
        'inspectionDate': value['inspectionDate'] == null ? undefined : ((value['inspectionDate']).toISOString()),
        'siteName': value['siteName'],
        'region': value['region'],
        'commodity': value['commodity'],
        'customerName': value['customerName'],
        'assetNumber': value['assetNumber'],
        'assetModel': value['assetModel'],
        'assetManufacturer': value['assetManufacturer'],
        'totalMachineHours': value['totalMachineHours'],
        'undercarriageInstallDateLeft': value['undercarriageInstallDateLeft'] === null ? null : ((value['undercarriageInstallDateLeft'] as any)?.toISOString()),
        'undercarriageInstallDateRight': value['undercarriageInstallDateRight'] === null ? null : ((value['undercarriageInstallDateRight'] as any)?.toISOString()),
        'undercarriageInstallHoursLeft': value['undercarriageInstallHoursLeft'],
        'undercarriageInstallHoursRight': value['undercarriageInstallHoursRight'],
        'undercarriageHoursLeft': value['undercarriageHoursLeft'],
        'undercarriageHoursRight': value['undercarriageHoursRight'],
        'totalPropelHours': value['totalPropelHours'],
        'propelHoursLeft': value['propelHoursLeft'],
        'propelHoursRight': value['propelHoursRight'],
        'components': value['components'] == null ? undefined : ((value['components'] as Array<any>).map(UndercarriageAllInspectionsComponentResponseToJSON)),
    };
}

